






















import click2Top from "@/common/directives/click2Top";
import PaginateModel from "@/model/paginate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Paginate from "vuejs-paginate";
@Component({
  name: "qPopupPaginate",
  components: {
    Paginate,
  },
  directives: {
    click2Top,
  },
})
export default class QPopupPaginate extends Vue {
  @Prop({ default: true })
  public replaceLocation: boolean;
  @Prop({ default: true })
  public scrollTop: boolean;
  @Prop({
    default: () => {
      return {
        page: 1,
        pageCount: 1,
      };
    },
  })
  public paginate!: PaginateModel;
  public page = 0;

  public changePage(page: any): void {
    console.log("page", page);
    this.$emit("page-change", { page });
  }

  get pagination(): PaginateModel {
    return this.paginate;
  }

  @Watch("paginate")
  public paginateChanged(newValue: PaginateModel): void {
    this.page !== newValue.page && (this.page = newValue.page);
  }
}
